import useSWR from "swr";
import { Table } from "antd";
import type { ColumnsType } from "antd/es/table";
import { Link, useParams } from "react-router-dom";
import { OrdersType } from "../../../shared/interfaces/requests.interface";
import { fetcher } from "../../../util/api";
import dayjs from "dayjs";
import { useCurrency } from "../../../hooks/useCurrency";
import { ChevronLeft, Loader } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { cn } from "../../../lib/utils";
import ManageFleetOwners from "../../../componentsV2/ManageFleetOwners";


const UserTransactions: React.FC = () => {
  const {formatCurrency} = useCurrency();
  const params = useParams();

  const { data: details } = useSWR<FleetOwner>(
    `/newAdmin/fleet-owner/${params?.fleetOwnerId}`,
    fetcher
  );

  const { data: transactions, error, isLoading, mutate } = useSWR(
    `/transactions/fleet-owner?fleetOwnerId=${params?.fleetOwnerId}`,
    fetcher
  );

  const columns: ColumnsType<OrdersType> = [
    {
      title: "Transaction ID",
      dataIndex: "invoiceId",
      key: "invoiceId",
      render: (_, record, index) => (
        <Link to={"/admin/requests/" + record.id}>{record?.invoiceId}</Link>
      ),
    },
    {
      title: "Date Created",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (_, record) => (
        <div>
          {dayjs(record.createdAt).format('DD/MM/YYYY')}
        </div>
      ),
    },    
    {
      title: "Value",
      dataIndex: "totalPrice",
      key: "totalPrice",
      render: (_, record) => (
        <div className="text-secondary">
          {formatCurrency(Number(record.amountCharged))}
        </div>
      ),
    },
    {
      title: "Loading Point",
      dataIndex: "pickupAddress",
      key: "pickupAddress",
      render: (_, record) => <div className="max-w-36 text-nowrap text-ellipsis overflow-hidden">{record.pickupAddress}</div>,
    },
    {
      title: "Status",
      dataIndex: "requestStatus",
      key: "requestStatus",
      render: (_, record) => (
        <div className="text-primary font-semibold">
          {record.requestStatus}
        </div>
      ),
    },
    {
      title: "Trips",
      dataIndex: "totalRequestTrips",
      key: "totalRequestTrips",
      render: (_, record, index) => (
        <span className="text-primary">{record.totalRequestTrips}</span>
      ),
    }
  ];

  return (
    <div className={cn("h-full grid grid-cols-1 gap-4 transition-all duration-300", details && "md:grid-cols-[1fr_350px]",)}>
      <div className="bg-white">
        <div className="flex items-center justify-between">
          <div className="my-8">
            <h1 className="text-lg mb-0 flex items-center gap-2 font-bold">
              <Button variant="ghost" className="text-blue-600" onClick={() => window.history.back()}>
                <ChevronLeft className="text-lg" />
                <span className="font-bold">Rental Requests</span>
              </Button>
            </h1>
          </div>
        </div>
        <div className="site-layout-background w-full overflow-auto p-4">
          {isLoading ? (<div className="text-center mt-5"><Loader /></div>) : (<Table columns={columns} dataSource={transactions?.earningTransactions ?? []} rowKey="id" />)}
        </div>
      </div>
      {!isLoading && details && <ManageFleetOwners selectedUser={details} handleClosePanel={() => {}} />}
    </div>
  );
};

export default UserTransactions;
